import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as Styled from './styles';

const BackToHub = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/');
    };

    return (
        <Styled.BackButton onClick={handleClick}>
            <Styled.Arrow>←</Styled.Arrow> Back to Sweepstakes Hub
        </Styled.BackButton>
    );
};

export default BackToHub;
